import { MutationTree } from "vuex";
import { StatisticState, DetailItem, WhatsappGroupItem } from "./types";

export const mutations: MutationTree<StatisticState> = {
  setWhatsappStatisticDetail: (state, data: DetailItem[]) => state.whatsappStatisticDetail = data,
  pushWhatsappStatisticDetail: (state, data: DetailItem[]) => state.whatsappStatisticDetail = state.whatsappStatisticDetail.concat(data),
  setWhatsappStatisticGroup: (state, data: WhatsappGroupItem[]) => state.whatsappStatisticGroup = data,
};